import { Grid } from "@mui/material";

import FormOne from "./CreateCampaignFirstForm";
import FormTwo from "./CreateCampaignSecondForm";
import FormThird from "./CreateCampaignThirdForm";
import CampaignLiveUser from "../CampaignLiveUser";
import FormFifth from "./CreateCampaignFifthForm";
import FormSeventh from "./PreferredCampaignChannel";
import ShowAudienceSizeDialog from "../ShowAudienceSize";
import { ButtonFooter, Paper } from "../../../../components";

export default function AllForms({
  audiences,
  editState,
  liveUsers,
  categories,
  formikProps,
  takeUpOffer,
  audienceData,
  setEditState,
  audienceSize,
  component = "",
  brandDetails,
  setBrandDetails,
  setAudienceData,
  setAudienceCreated,
  preferredChannels,
  tabValue,
  brandIdentity,
  channelSectionRef,
  forceClick,
  isSubmitted,
}) {
  return (
    <Grid container spacing={2}>
      {tabValue === "Campaign" && (
        <Grid size={12}>
          <Paper gridSpacing={6}>
            <FormOne
              categories={categories}
              brandDetails={brandDetails}
              setBrandDetails={setBrandDetails}
              formikProps={formikProps}
              editState={editState}
              component={component}
              brandIdentity={brandIdentity}
            />
          </Paper>

          <Paper gridSpacing={6}>
            <FormTwo
              setAudienceData={setAudienceData}
              formikProps={formikProps}
              audiences={audiences}
              editState={editState}
              component={component}
              brandIdentity={brandIdentity}
              audienceData={audienceData}
              setAudienceCreated={setAudienceCreated}
            />
          </Paper>

          <Paper gridSpacing={6}>
            <FormThird
              brandIdentity={brandIdentity}
              formikProps={formikProps}
              editState={editState}
              component={component}
            />
          </Paper>

          {component !== "request" && (
            <Grid size={12} ref={channelSectionRef}>
              <Paper gridSpacing={6}>
                <FormSeventh
                  editState={editState}
                  formikProps={formikProps}
                  preferredChannels={preferredChannels}
                  channelSectionRef={channelSectionRef}
                  forceClick={forceClick}
                  isDisabled={isSubmitted}
                />
              </Paper>
            </Grid>
          )}

          {editState && (
            <Grid size={12}>
              <ButtonFooter
                ID={formikProps.values.campaignID}
                editState={editState}
                setEditState={setEditState}
                formikProps={formikProps}
              />
            </Grid>
          )}

          {!!(audienceSize?.audience_params || audienceSize?.audience_size) && (
            <ShowAudienceSizeDialog
              audienceSize={audienceSize}
              formikProps={formikProps}
            />
          )}

          {brandIdentity && (
            <CampaignLiveUser
              takeUpOffer={takeUpOffer}
              liveUsers={liveUsers}
              component={component}
            />
          )}
        </Grid>
      )}

      {formikProps.values.campaignID && tabValue !== "Campaign" && (
        <Grid size={12}>
          <Paper gridSpacing={6}>
            <FormFifth
              formikProps={formikProps}
              editState={editState}
              component={component}
              brandIdentity={brandIdentity}
            />
          </Paper>
        </Grid>
      )}
    </Grid>
  );
}
